module.exports = __webpack_public_path__ + "static/media/wjPie.5e28d9fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/wjPie.png
// module id = 689
// module chunks = 0 1